import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { fetchConfig } from "utils";

const useReadingStats = () => {
	const { accessToken } = useTokenStore();

	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const res = await instance.get("users/me/reading-stats");
		return res.data?.data;
	};

	return useQuery(["reading-stats"], () => fetch(), {
		...fetchConfig,
	});
};

export default useReadingStats;
